import { Menu } from '@services/MarppleShop/renderApp/components/cells/Header/libs/types/header';
import { generateProductRankingUrl } from '@services/MarppleShop/renderApp/pages/ProductRanking/utils/generateProductRankingUrl.ts';

export const MENU_MAP = {
  Creator: 'Creator',
  'Pop-up Store': 'Pop-up Store',
  Shop: 'Shop',
};

export const getMenu = (selected_menu?: keyof typeof MENU_MAP): Menu[] => {
  return [
    {
      name: ET('mps2::gnb::menu::creator'),
      url: '/@/creator/ranking/realtime',
      key: 'Creator',
      is_selected: selected_menu === 'Creator',
    },
    {
      name: ET('mps2::gnb::menu::popup'),
      url: '/@/popup-store',
      key: 'Pop-up Store',
      is_selected: selected_menu === 'Pop-up Store',
    },
    {
      name: ET('mps2::gnb::menu::shopping'),
      url: generateProductRankingUrl(ET.lang, {
        rank_type: 'realtime',
      }),
      key: 'Shop',
      is_selected: selected_menu === 'Shop',
    },
  ];
};
